module.exports = __webpack_public_path__ + "img/horizontal-logo-pink.1580aecc.svg";